export default {
      id: "slash-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "sprite.svg#slash",
      toString: function () {
        return this.url;
      }
    }